import { f as i, e as l, j as r } from "./index-5HZ18Wug.js";
import { i as j } from "./translation-EA7nJRmX.js";
import { T as y, V as v, B as L } from "./Spinner-OWhkXHB5.js";
import { styled as t, css as d } from "styled-components";
import { r as T, T as w, d as n, j as B, e as M, p as c, c as p } from "./style-V_Aar-SK.js";
import { T as k } from "./typography.styled-kbi3nh6Q.js";
import { u as A } from "./useMetaContent-M9Eg3hyC.js";
const q = t.div.attrs({ $flexDirection: "column", $alignItems: "center" })`
  ${i};

  margin: auto;
  margin-top: ${l.spacer3};
  max-width: ${T(220)};
`, F = t(k).attrs({ $variant: w.bodyS, as: "span", "aria-live": "polite" })`
  margin-bottom: ${l.spacer2};
  ${n("color", "dominantAlpha80")};
`, P = t.div.attrs({ $justifyContent: "flex-end" })`
  ${i};
  ${n("background-color", "dominantAlpha10")};

  width: 100%;
`, S = t.div`
  ${B("width", M.base)};
  ${n("background-color", "dominant")};

  width: ${({ $progress: a }) => a ? `${a}%` : 0};
  height: 3px;

  ${c(d`
    border: 2px solid ${p.greyAlpha10};
  `)}
`, V = t.div`
  align-self: center;
  width: inherit;

  ${c(d`
    border: 1px solid ${p.black};
  `)}
`, J = ({
  isLoading: a,
  onLoadMore: e,
  totalItemsCount: o,
  displayedItemsCount: s,
  theme: m,
  t: h
}) => {
  const x = A("font-family"), { loadMoreLabel: $, loadMoreShowLabel: f, loadMoreLoadingLabel: g } = h, u = () => {
    e && e();
  }, b = s < o;
  return /* @__PURE__ */ r.jsx(y, { theme: m, children: /* @__PURE__ */ r.jsxs(q, { "data-qa": "load-more-button", children: [
    a && /* @__PURE__ */ r.jsx(v, { "aria-live": "assertive", children: g }),
    /* @__PURE__ */ r.jsx(F, { $fontFamily: x, children: j(f, { current: s, total: o }) }),
    !!o && /* @__PURE__ */ r.jsx(W, { value: s, max: o }),
    b && /* @__PURE__ */ r.jsx(
      L,
      {
        onClick: u,
        variant: "secondary",
        state: a ? "loading" : "active",
        fullWidth: !0,
        $my: "spacer3",
        children: $
      }
    )
  ] }) });
}, W = ({ value: a, max: e }) => {
  const o = a / e * 100, s = o < 100 ? o : 100;
  return e ? /* @__PURE__ */ r.jsx(P, { children: /* @__PURE__ */ r.jsx(V, { children: /* @__PURE__ */ r.jsx(S, { $progress: s, "data-qa": "loadmore-progress" }) }) }) : null;
};
export {
  J as L,
  W as a
};
